import { Sparkles } from 'lucide-react';
import { useActiveOrganization } from '../../contexts/auth';
import { CreateInterviewTypeFormContainer } from '../../contexts/interview-types';

export function InterviewTypeCreatePage() {
  const { organization } = useActiveOrganization();

  return (
    <div className="space-y-6">
      <header className="space-y-1.5">
        <div className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.14em] text-muted-foreground">
          <Sparkles className="h-3.5 w-3.5" strokeWidth={2} />
          New template
        </div>
        <h1 className="text-[22px] font-semibold leading-tight tracking-tight text-foreground">
          Create an interview template
        </h1>
        <p className="text-[13.5px] leading-relaxed text-muted-foreground max-w-2xl">
          A template captures the prompts that shape every interview run from it, plus the JSON
          schema for the structured summary you get back.
        </p>
      </header>

      {organization && <CreateInterviewTypeFormContainer orgId={organization.id} />}
    </div>
  );
}
